import { actionCreator } from 'utils';
import {
    LOAD_COATING_OUT,
    CREATE_JOB_PALETTE,
    DELETE_COATING_OUT_JOB,
    CONFIRM_PALETTE,
    LOAD_JOB_PALETTES_OUT,
    SET_CHECKED_JOB_RESULT_OUT,
    ADD_NEW_PALETTE_OUT,
    PRINT_PALETTE_OUT,
    SET_CHECKED_JOB_RESULT_RECORD_OUT,
    SHOW_ADD_NEW_PALETTE_POPUP_OUT,
    HIDE_ADD_NEW_PALETTE_POPUP_OUT,
    SET_IS_COATING_OUT_MODAL_VISIBLE,
    SET_IS_TOTAL_QUANTITY_SELECTED,
    SET_COATINGOUT_FILTERS,
    RESET_COATING_OUT_FILTERS,
    SET_JOB_PALETTES_OUT_FILTERS,
    RESET_JOB_PALETTES_OUT_FILTERS,
} from '../types/coatingOutTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    limit: 50,
    offset: 0,
    paletteCreated: false,
    submitting: false,
    showAddNewPalette: false,
    isModalVisible: false,
    isTotalQuantitySelected: false,
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    filters: {
        order_id: '',
        order_item_id: '',
        customer: '',
    },
    filtersJobPalettesOut: {
        order_id: '',
        order_item_id: '',
        customer: '',
    },
    jobPalettesOut: {
        loading: false,
        error: false,
        listing: null,
    },
    createJobPalette: {
        loading: false,
        error: false,
        success: false,
    },
    deleteJob: {
        loading: false,
        error: false,
        success: false,
    },
    confirmPalette: {
        loading: [],
        error: false,
        success: false,
    },

    checked: {
        loading: false,
        ids: [],
        selected: [],
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case LOAD_COATING_OUT:
        return Object.assign({}, state, {
            loading: true,
            error: false,
        });

    case actionCreator(LOAD_COATING_OUT, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(LOAD_COATING_OUT, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case SET_COATINGOUT_FILTERS:
        return Object.assign({}, state, {
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case RESET_COATING_OUT_FILTERS:
        return Object.assign({}, state, {
            filters: initState.filters,
        });

    case LOAD_JOB_PALETTES_OUT:
        return Object.assign({}, state, {
            jobPalettesOut: Object.assign({}, state.jobPalettesOut, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(LOAD_JOB_PALETTES_OUT, 'res'):
        return Object.assign({}, state, {
            jobPalettesOut: Object.assign({}, state.jobPalettesOut, {
                loading: false,
                listing: action.data,
            }),
        });

    case actionCreator(LOAD_JOB_PALETTES_OUT, 'err'):
        return Object.assign({}, state, {
            jobPalettesOut: Object.assign({}, state.jobPalettesOut, {
                error: true,
                loading: false,
            }),
        });

    case SET_JOB_PALETTES_OUT_FILTERS:
        return Object.assign({}, state, {
            filtersJobPalettesOut: {
                ...state.filtersJobPalettesOut,
                [action.key]: action.value,
            },
        });

    case RESET_JOB_PALETTES_OUT_FILTERS:
        return Object.assign({}, state, {
            filtersJobPalettesOut: initState.filtersJobPalettesOut,
        });

    case CREATE_JOB_PALETTE:
        return Object.assign({}, state, {
            createJobPalette: Object.assign({}, state.createJobPalette, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(CREATE_JOB_PALETTE, 'res'):
        return Object.assign({}, state, {
            isTotalQuantitySelected: false,
            createJobPalette: Object.assign({}, state.createJobPalette, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(CREATE_JOB_PALETTE, 'err'):
        return Object.assign({}, state, {
            isTotalQuantitySelected: false,
            createJobPalette: Object.assign({}, state.createJobPalette, {
                loading: false,
                success: false,
                error: action.error,
            }),
        });

    case DELETE_COATING_OUT_JOB:
        return Object.assign({}, state, {
            deleteJob: Object.assign({}, state.deleteJob, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(DELETE_COATING_OUT_JOB, 'res'):
        return Object.assign({}, state, {
            deleteJob: Object.assign({}, state.deleteJob, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(DELETE_COATING_OUT_JOB, 'err'):
        return Object.assign({}, state, {
            deleteJob: Object.assign({}, state.deleteJob, {
                loading: false,
                success: false,
                error: action.error,
            }),
        });

    case CONFIRM_PALETTE:
        return Object.assign({}, state, {
            confirmPalette: Object.assign({}, state.confirmPalette, {
                loading: [
                    ...state.confirmPalette.loading,
                    action.paletteId,
                ],
                error: false,
            }),
        });

    case actionCreator(CONFIRM_PALETTE, 'res'):
        return Object.assign({}, state, {
            confirmPalette: Object.assign({}, state.confirmPalette, {
                loading: state.confirmPalette.loading.filter(c => !action.payload.includes(c)),
                success: action.success,
            }),
        });

    case actionCreator(CONFIRM_PALETTE, 'err'):
        return Object.assign({}, state, {
            confirmPalette: Object.assign({}, state.confirmPalette, {
                loading: [],
                success: false,
                error: action.error,
            }),
        });

    case SET_CHECKED_JOB_RESULT_OUT:
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                ids: action.ids,
            },
        });

    case SET_CHECKED_JOB_RESULT_RECORD_OUT:
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                selected: action.data,
            },
        });

    case ADD_NEW_PALETTE_OUT:
        return Object.assign({}, state, {
            ...state,
            submitting: true,
        });

    case actionCreator(ADD_NEW_PALETTE_OUT, 'res'):
        return Object.assign({}, state, {
            ...state,
            submitting: false,
            paletteCreated: true,
        });

    case actionCreator(ADD_NEW_PALETTE_OUT, 'err'):
        return Object.assign({}, state, {
            paletteCreated: false,
            submitting: false,
        });

    case SHOW_ADD_NEW_PALETTE_POPUP_OUT:
        return Object.assign({}, state, {
            paletteCreated: false,
            showAddNewPalette: true,
        });

    case HIDE_ADD_NEW_PALETTE_POPUP_OUT:
        return Object.assign({}, state, {
            showAddNewPalette: false,
            paletteCreated: false,
            checked: {
                ...state.checked,
                loading: false,
                ids: [],
                selected: [],
            },
        });

    case actionCreator(PRINT_PALETTE_OUT, 'res'):
        return Object.assign({}, state, {
            paletteCreated: false,
            showAddNewPalette: false,
            checked: {
                ...state.checked,
                loading: false,
                ids: [],
                selected: [],
            },
        });

    case actionCreator(PRINT_PALETTE_OUT, 'err'):
        return Object.assign({}, state, {
            paletteCreated: false,
            showAddNewPalette: false,
        });

    case SET_IS_COATING_OUT_MODAL_VISIBLE:
        return Object.assign({}, state, {
            isModalVisible: action.data,
        });

    case SET_IS_TOTAL_QUANTITY_SELECTED:
        return Object.assign({}, state, {
            isTotalQuantitySelected: action.data,
        });

    default:
        return state;
    }
}
